<template>
  <div class="station-manage-page">
    <div class="nav-header">
      <i class="el-icon-arrow-left" @click="$router.back()"></i>
      <span class="title">站点管理</span>
      <span class="placeholder"></span>
    </div>

    <div class="stats-header">
      <div class="stats-row">
        <div class="stat-item">
          <p class="label">订单总额 (元)</p>
          <p class="value">{{ statsData.orderAmount }}</p>
        </div>
        <div class="stat-item">
          <p class="label">充电度数 (度)</p>
          <p class="value">{{ statsData.powerAmount }}</p>
        </div>
        <div class="stat-item">
          <p class="label">订单量 (单)</p>
          <p class="value">{{ statsData.orderCount }}</p>
        </div>
      </div>
    </div>

    <div class="station-list-section">
      <div class="section-title">
        <i class="el-icon-office-building"></i>
        <span>场站列表</span>
      </div>

      <div class="station-card" v-for="item in stationList" :key="item.id">
        <div class="card-header">
          <div class="station-info">
            <p class="name"><i class="el-icon-school"></i> {{ item.plotName }}</p>
            <p class="address">{{ item.address }}</p>
          </div>
          <div class="status-tag" :class="item.onlineCount > 0 ? 'online' : 'offline'">
            {{ item.onlineCount || 0 }}台在线
          </div>
        </div>
        <div class="card-stats">
          <div class="s-item">
            <span class="s-label">今日收益</span>
            <span class="s-value">{{ item.todayAmount || '0.00' }}</span>
          </div>
          <div class="s-item">
            <span class="s-label">今日订单</span>
            <span class="s-value">{{ item.todayCount || 0 }}</span>
          </div>
          <div class="s-item">
            <span class="s-label">设备总数</span>
            <span class="s-value">{{ item.totalPiles || 0 }}</span>
          </div>
        </div>
      </div>

      <div class="empty-state" v-if="stationList.length === 0">
        <i class="el-icon-folder-opened" style="font-size: 50px; color: #ccc;"></i>
        <p>暂无场站数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getPlotList, getDayProfit } from "@/api/newApi";

export default {
  name: 'StationManage',
  data() {
    return {
      currentStation: '全部场站',
      searchKey: '',
      stationList: [],
      statsData: {
        orderAmount: '0.00',
        yesterdayAmount: '0.00',
        powerAmount: '0.00',
        yesterdayPower: '0.00',
        orderCount: 0,
        yesterdayCount: 0
      }
    };
  },
  mounted() {
    this.getStationList();
    this.getStatsData();
  },
  methods: {
    async getStationList() {
      try {
        const res = await getPlotList({ pageNo: 1, pageSize: 100 });
        console.log('场站列表返回:', res);
        let listData = res.data;
        if (res.data && res.data.records) {
          listData = res.data.records;
        }
        if (listData && listData.length > 0) {
          this.stationList = listData.map(item => ({
            ...item,
            todayAmount: '0.00',
            todayCount: 0,
            totalPiles: item.pileNum || 0,
            onlineCount: (item.pileNum || 0) - (item.offlinePileNum || 0)
          }));
          this.getStationStats();
        }
      } catch (err) {
        console.log('获取场站列表失败', err);
      }
    },
    async getStationStats() {
      try {
        const today = new Date();
        const y = today.getFullYear();
        const m = String(today.getMonth() + 1).padStart(2, '0');
        const d = String(today.getDate()).padStart(2, '0');
        const todayStr = `${y}-${m}-${d}`;

        for (let item of this.stationList) {
          const profitRes = await getDayProfit({ startTime: todayStr, endTime: todayStr });
          if (profitRes.data) {
            item.todayAmount = profitRes.data.sumOrdergold || '0.00';
          }
        }
      } catch (err) {
        console.log('获取场站统计数据失败', err);
      }
    },
    async getStatsData() {
      try {
        const today = new Date();
        const y = today.getFullYear();
        const m = String(today.getMonth() + 1).padStart(2, '0');
        const d = String(today.getDate()).padStart(2, '0');
        const todayStr = `${y}-${m}-${d}`;

        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const ym = String(yesterday.getMonth() + 1).padStart(2, '0');
        const yd = String(yesterday.getDate()).padStart(2, '0');
        const yesterdayStr = `${y}-${ym}-${yd}`;

        const [todayRes, yesterdayRes] = await Promise.all([
          getDayProfit({ startTime: todayStr, endTime: todayStr }),
          getDayProfit({ startTime: yesterdayStr, endTime: yesterdayStr })
        ]);

        this.statsData.orderAmount = todayRes.data?.sumOrdergold || '0.00';
        this.statsData.yesterdayAmount = yesterdayRes.data?.sumOrdergold || '0.00';
      } catch (err) {
        console.log('获取统计数据失败', err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.station-manage-page {
  background-color: #F6F8FA;
  min-height: 100vh;
  padding-bottom: 30px;
}

.nav-header {
  background: #FFF;
  padding: 15px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title { font-size: 18px; font-weight: bold; }
  i { font-size: 20px; }
  .placeholder { width: 20px; }
}

.stats-header {
  background: #FFF;
  margin: 12px 16px;
  border-radius: 12px;
  padding: 16px;
  .stats-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    .stat-item {
      text-align: center;
      cursor: pointer;
      .label { font-size: 12px; color: #999; margin-bottom: 8px; }
      .value { font-size: 20px; font-weight: bold; color: #333; }
      .yesterday { font-size: 11px; color: #999; margin-top: 4px; }
    }
  }
}

.station-list-section {
  margin: 0 16px;
  .section-title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    i { color: #00BFA5; margin-right: 8px; }
    span { font-size: 17px; font-weight: bold; }
  }
}

.station-card {
  background: #FFF;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
    .station-info {
      flex: 1;
      .name {
        font-size: 15px;
        font-weight: bold;
        i { color: #4A90E2; margin-right: 6px; }
      }
      .address {
        font-size: 12px;
        color: #999;
        margin-top: 4px;
      }
    }
    .status-tag {
      font-size: 11px;
      padding: 4px 8px;
      border-radius: 10px;
      &.online { background: #E8F9ED; color: #52C41A; }
      &.offline { background: #FFF1F0; color: #FF4D4F; }
    }
  }
  .card-stats {
    display: flex;
    justify-content: space-between;
    background: #F8FAFB;
    padding: 12px;
    border-radius: 8px;
    .s-item {
      text-align: center;
      .s-label { font-size: 11px; color: #999; margin-bottom: 4px; }
      .s-value { font-size: 15px; font-weight: bold; color: #333; }
    }
  }
}

.empty-state {
  text-align: center;
  padding: 60px 0;
  p { color: #999; font-size: 14px; margin-top: 12px; }
}
</style>